const { hostname } = window.location;
// eslint-disable-next-line no-nested-ternary
export const env = hostname.indexOf('test') > -1
  ? 'dev'
  : (hostname.indexOf('localhost') > -1 ? 'local' : 'prod');
